import { wrap, wrapGql } from "../_"

type OauthProvider = string // TODO

const pfx = "/login"

export default (a: NuxtAxiosInstance) => ({
  getOauthUrl:
    (provider: OauthProvider, redirectUrl: string, cfg?: AxiosConfig) =>
      wrap(
        a.$get(`${pfx}/oauth/${provider}`,
          { params: { redirectUrl }, ...cfg })),

  getOwnerData: (
    provider: OauthProvider,
    redirectUrl: string,
    code: string,
    deviceID?: string,
    cfg?: AxiosConfig,
  ) => wrap(
    a.$get(`${pfx}/oauth/${provider}/owner`,
      {
        params: {
          redirectUrl,
          code,
          deviceID,
        },
        ...cfg,
      })),

  initLogin: (username: string, password: string) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        mutation (
          $username: String!
          $password: String!
        ) {
          initLogin(
            username: $username
            password: $password
          )
        }
      `,
      variables: {
        username,
        password,
      },
    }),
    "initLogin",
  ),

  loginWith2FA: (token: string, code: string) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        mutation (
          $token: String!
          $code: String!
        ) {
          loginWith2FA (
            token: $token
            code: $code
          )
        }
      `,
      variables: {
        token,
        code,
      },
    }),
    "loginWith2FA",
  ),

  resend2FACode: (token: string) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        mutation (
          $token: String!
        ) {
          resend2FACode(
            token: $token
          )
        }
      `,
      variables: {
        token,
      },
    }),
    "resend2FACode",
  ),
})
